<template>
    <div class="flex align-items-center gap-2 custom-checkbox" :class="error ? 'error' : ''">
        <label :for="name" :class="computedClasses" class="checkbox-label" :disabled="disabled">
            <span class="star" v-if="rules">*</span>{{ label }}:
        </label>
        <Checkbox :inputId="name" v-model="internalValue" :class="computedClasses"
                  @change="change" @blur="handleBlur" :binary="true"
                  :disabled="disabled"/>
    </div>
</template>

<script>
import Checkbox from "primevue/checkbox";
    import {useField} from "vee-validate";

    export default {
        name: "CustomCheckbox",

        components: {Checkbox},

        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            required: {
                type: Boolean,
                default: false,
            },
            error: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            upperCase: {
                type: Boolean,
                default: true,
            },
            rules: undefined,
            modelValue: null,
        },

        emits: ["update:modelValue", "change"],

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                    this.$emit("change", value);
                },
            },

            computedClasses() {
                let classes = "";
                if (this.upperCase) classes += "uppercase";
                if (this.errorMessage) classes += "p-invalid";
                return classes;
            },
        },

        setup(props) {
            const {
                value: inputValue,
                errorMessage,
                handleBlur,
                handleChange,
                meta,
            } = useField(props.name, props.rules, {
                initialValue: props.modelValue,
            });

            return {
                handleChange,
                handleBlur,
                errorMessage,
                inputValue,
                meta,
            };
        },

        methods: {
            change() {
                this.handleChange(!this.internalValue);
            },
        },

    };
</script>

<style lang="scss">
    @import "../../assets/theme/mytheme/variables";
    .custom-checkbox {
        .checkbox-label {
            font-size: 1rem;
            line-height: 19px;
        }
        .p-checkbox {
            width: 25px;
            height: 25px;
            .p-checkbox-box {
                width: 25px;
                height: 25px;
                border: 1px solid var(--primary-color);
            }
        }
    }
    .star {
        font-size: 1rem;
        color: var(--red-500);
        font-weight: 700;
    }
    .error {
        color: var(--red-500);
    }
</style>
